import React from 'react';
import { Routes, Route, NavLink, Navigate, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import SessionStatus from './components/session/SessionStatus';
import './App.css';
import Home from './pages/Home';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import Dashboard from './pages/Dashboard';
import ImageProcessingPage from './pages/ImageProcessingPage';
import AdminConsole from './pages/AdminConsole';
import ImageModeSelector from './pages/ImageModeSelector';
import TwoDProcessingPage from './pages/TwoDProcessingPage';

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

const AppContent = () => {
  const { isAuthenticated, logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="App">
      <nav className="App-nav">
        <div className="nav-inner">
          <span className="App-brand">ObjGen</span>
          <ul>
            <li>
              <NavLink to="/" end>
                Home
              </NavLink>
            </li>
            {isAuthenticated && (
              <>
                <li>
                  <NavLink to="/dashboard">
                    Dashboard
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/image-tools">
                    Image Processing
                  </NavLink>
                </li>
                {/** Admin-only nav item (client-side guard) */}
                {user?.is_admin && (
                  <li>
                    <NavLink to="/admin">Admin</NavLink>
                  </li>
                )}
              </>
            )}
            {!isAuthenticated && (
              <li>
                <NavLink to="/login">
                  Login
                </NavLink>
              </li>
            )}
            {!isAuthenticated && (
              <li>
                <NavLink to="/register">
                  Register
                </NavLink>
              </li>
            )}
            {isAuthenticated && (
              <li>
                <button type="button" className="nav-logout" onClick={handleLogout}>
                  Logout
                </button>
              </li>
            )}
          </ul>
        </div>
      </nav>

      {isAuthenticated && <SessionStatus />}
      
      <main className="App-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/image-processing"
            element={
              <ProtectedRoute>
                <ImageProcessingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/image-2d"
            element={
              <ProtectedRoute>
                <TwoDProcessingPage mode="2d" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/image-3d-edit"
            element={
              <ProtectedRoute>
                <TwoDProcessingPage mode="3d" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/image-tools"
            element={
              <ProtectedRoute>
                <ImageModeSelector />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute requireAdmin>
                <AdminConsole />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
};

export default App;
